
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-cases",
      function () {
        return require("private-next-pages/new-cases.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-cases"])
      });
    }
  